import React from "react";

export default function Laboratorium() {
  return (
    <table className="table-auto w-full lg:w-5/6  text-center my-3 mb-12">
      <thead>
        <tr className=" border">
          <th className="border border-slate-300 p-2">Hari</th>
          <th className="border border-slate-300 p-2">Pukul</th>
        </tr>
      </thead>
      <tbody>
        <tr className="">
          <td className="border border-slate-300 p-1">Senin - Sabtu</td>
          <td className="border border-slate-300 p-1">
            08.00 - 13.00 <br /> 16.00 - 20.00
          </td>
        </tr>
        <tr className="">
          <td className="border border-slate-300 p-1">Minggu</td>
          <td className="border border-slate-300 p-1">08.00 - 12.00</td>
        </tr>
      </tbody>
    </table>
  );
}
